import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Service from '../../../apis/service';
import { ErrorToast } from '../../utils/Utils';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { showProgress } from '../../../redux/actions/DealershipActions';

const useFetchDepartments = () => {
  const dispatch = useDispatch();
  const [departmentData, setDepartmentData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(showProgress(true));
      try {
        const res = await Service.post(apiEndpoints.CON_DEPT);
        setDepartmentData(res);
      } catch (er) {
        setError(er);
        ErrorToast(er || 'An error occurred');
      } finally {
        dispatch(showProgress(false));
      }
    };

    fetchData();
  }, []);

  return { departmentData, error };
};

export default useFetchDepartments;
